import React, { useEffect, useState } from "react";
import { Stack, Box, Modal, IconButton } from "@mui/material";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";

import LinkText from "components/LinkText";
import { getServerURL } from "utils/serverUrl";

export default function Footer() {
  const theme = useTheme();
  const fontColor = theme.palette.primary.greyPrimary;

  const currentYear = new Date().getFullYear();
  const rawVersion =
    process.env.REACT_APP_APIM_VERSION || "";
  const apimVersion = rawVersion.split("-")[0];

  const [open, setOpen] = useState(false);
  const [agreementType, setAgreementType] = useState("");

  const handleOpen = (type) => {
    setAgreementType(type);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setAgreementType("");
  };

  const getTitle = () => {
    if (agreementType === "terms") return "Terms";
    if (agreementType === "privacy") return "Privacy";
    return "";
  };

  const getAgreementUrl = () => {
    const serverUrl = getServerURL();

    return `${serverUrl}/agreement?type=${agreementType}`;
  };

  const renderTrustarc = () => {
    const trustarcDom = document.querySelector("#teconsent");
    const trustarcBlackbar = document.querySelector("#consent_blackbar");

    if (trustarcDom) {
      trustarcDom.innerHTML = "";
    }

    if (trustarcBlackbar) {
      trustarcBlackbar.innerHTML = "";
    }

    const langCode = "en";

    const trustarcUrl =
      `//consent.trustarc.com/notice?domain=mydlink.com` +
      `&c=teconsent` +
      `&js=nj` +
      `&noticeType=bb` +
      `&text=true` +
      `&language=${langCode}` +
      `&gtm=1`;

    const bodyDom = document.querySelector("body");
    const scriptDom = document.createElement("script");

    scriptDom.setAttribute("async", "async");
    scriptDom.setAttribute("src", trustarcUrl);
    scriptDom.setAttribute("crossorigin", "anonymous");

    if (bodyDom) {
      bodyDom.appendChild(scriptDom);
    }
  };

  useEffect(() => {
    renderTrustarc();
  }, []);

  return (
    <>
      <Stack
        direction="column"
        alignItems="center"
        sx={{
          p: "24px 16px 0px",
          mt: "auto",
        }}
      >
        <Typography
          variant="caption"
          sx={{
            color: fontColor,
            textAlign: "center",
            fontSize: theme.typography.customFontSize[1],
          }}
        >
          D-Link is a registered trademark of D-Link Corporation and its
          overseas subsidiaries.
          <br />
          All other trademarks belong to their respective owners.©
          {currentYear} D-Link Corporation. All rights reserved.
        </Typography>

        <Typography
          variant="caption"
          sx={{
            color: fontColor,
            textAlign: "center",
            fontSize: theme.typography.customFontSize[3],
          }}
        >
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            gap={0.5}
          >
            {/* Terms */}
            <LinkText>
              <Box
                onClick={() => handleOpen("terms")}
                sx={{
                  cursor: "pointer",
                }}
              >
                Terms
              </Box>
            </LinkText>

            ⏐

            {/* Privacy */}
            <LinkText>
              <Box
                onClick={() => handleOpen("privacy")}
                sx={{
                  cursor: "pointer",
                }}
              >
                Privacy
              </Box>
            </LinkText>

            ⏐

            {/* Cookie */}
            <LinkText>
              <Box
                id="teconsent"
                className="trustarc-link"
                sx={{
                  cursor: "pointer",
                }}
              >
                Cookie Preferences
              </Box>
            </LinkText>

            ⏐

            {/* Version */}
            <Box component="span">
              Version({apimVersion})
            </Box>
          </Box>
        </Typography>
      </Stack>

      {/* Terms / Privacy Modal */}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="agreement-modal-title"
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "rgba(0, 0, 0, 0.5)",
            },
          },
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",

            width: "800px",
            maxWidth: "90vw",

            height: "50vh",
            maxHeight: "800px",

            bgcolor: "#FFFFFF",

            borderRadius: "12px",
            border: "none",

            // 不要黑色陰影
            boxShadow: "none",

            // 不要 focus 黑框
            outline: "none",

            "&:focus": {
              outline: "none",
            },

            "&:focus-visible": {
              outline: "none",
            },

            display: "flex",
            flexDirection: "column",

            overflow: "hidden",
          }}
        >
          {/* Header */}
          <Box
            sx={{
              height: "64px",
              flexShrink: 0,

              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",

              px: 3,

              borderBottom: "1px solid #E5E5E5",
            }}
          >
            <Typography
              id="agreement-modal-title"
              sx={{
                fontSize: "20px",
                fontWeight: 600,
                color: fontColor,
              }}
            >
              {getTitle()}
            </Typography>

            <IconButton
              onClick={handleClose}
              size="small"
              sx={{
                outline: "none",

                "&:focus": {
                  outline: "none",
                },

                "&:focus-visible": {
                  outline: "none",
                },
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          {/* Content */}
          <Box
            sx={{
              flex: 1,
              minHeight: 0,
              overflow: "hidden",
            }}
          >
            {agreementType && (
              <Box
                component="iframe"
                src={getAgreementUrl()}
                title={getTitle()}
                sx={{
                  display: "block",
                  width: "100%",
                  height: "100%",
                  border: "none",
                  outline: "none",
                }}
              />
            )}
          </Box>
        </Box>
      </Modal>

      <Box
        id="consent_blackbar"
        className="trustarc-blackbar"
        sx={{
          position: "fixed",
          left: 0,
          right: 0,
          bottom: 0,
          width: "100%",
          zIndex: 9999,
        }}
      />
    </>
  );
}